import DateService from "./DateService";

export const generateBreadcrumbSegmentsAdmin = ({ entreprise, contrat, activite, seance, participation, utilisateur, role, justificatifType, activiteType }) => {
    const segments = [];
    segments.push({
        path: '/admin/entreprises',
        name: 'Entreprises'
    });
    segments.push({
        path: `/admin/utilisateurs`,
        name: 'Utilisateurs'
    });
    segments.push({
        path: `/admin/roles`,
        name: 'Rôles'
    });
    segments.push({
        path: `/admin/justificatifs/types`,
        name: 'Types de justificatifs'
    });
    segments.push({
        path: `/admin/activites/types`,
        name: "Types d'activités"
    });
    segments.push({
        path: `/admin/seances`,
        name: "Toutes les séances"
    });
    segments.push({
        path: `/admin/absences`,
        name: "Absences de coachs"
    });
    segments.push({
        path: `/admin/crm`,
        name: "CRM"
    });
    segments.push({
        path: `/admin/crm/types`,
        name: "Types"
    });
    segments.push({
        path: `/admin/crm/user_history`,
        name: "Historique"
    });
    segments.push({
        path: `/admin/crm/user_optin`,
        name: "Actions"
    });
    if (entreprise && entreprise.id) {
        segments.push({
            path: `/admin/entreprises/${entreprise?.id}`,
            name: entreprise?.nom || 'Entreprise'
        });
        segments.push({
            path: `/admin/entreprises/${entreprise?.id}/contrats`,
            name: 'Contrats'
        });
        segments.push({
            path: `/admin/entreprises/${entreprise?.id}/salaries`,
            name: 'Salariés'
        });
        if (contrat && contrat.id) {
            segments.push({
                path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}`,
                // name: contrat?.id || 'Contrat',
                name: DateService.formatFrenchDateWithoutTime(contrat?.date_start) ?? 'Contrat'

            });
            segments.push({
                path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites`,
                name: 'Activités'
            });
            if (activite && activite.id) {
                segments.push({
                    path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites/${activite?.id}`,
                    name: activite?.type?.nom || 'Activité'
                });
                segments.push({
                    path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites/${activite?.id}/seances`,
                    name: 'Séances'
                });
                if (seance && seance.id) {
                    segments.push({
                        path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites/${activite?.id}/seances/${seance?.id}`,
                        name: DateService.formatDateJoli(seance?.date)
                    });
                    segments.push({
                        path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites/${activite?.id}/seances/${seance?.id}/participations`,
                        name: "Participations"
                    });
                    if (participation && participation.id) {
                        segments.push({
                            path: `/admin/entreprises/${entreprise?.id}/contrats/${contrat?.id}/activites/${activite?.id}/seances/${seance?.id}/participations/${participation?.id}`,
                            name: participation?.participant?.prenom + " " + participation?.participant?.nom || 'Participation'
                        });
                    }
                }
            }
        } else if (utilisateur && utilisateur.id) {
            segments.push({
                path: `/admin/entreprises/${entreprise?.id}/salaries/${utilisateur?.id}`,
                name: utilisateur?.prenom + " " + utilisateur?.nom  || 'Salarié'
            });
        }
    }
    if (utilisateur && utilisateur.id) {
        segments.push({ path: `/admin/utilisateurs/${utilisateur.id}`, name: (utilisateur.prenom + " " + utilisateur.nom) || 'Utilisateur' });
    }
    if (role && role.role) {
        segments.push({ path: `/admin/roles/${role.role}`, name: role.role || 'Rôle' });
        segments.push({ path: `/admin/roles/${role.role}/justificatifs`, name: "Justificatifs" });
    }
    if (justificatifType && justificatifType.justId) {
        segments.push({
            path: `/admin/justificatifs/types/${justificatifType.justId}`,
            name: justificatifType.justLabel || 'Type de justificatif'
        });
    }
    if (activiteType && activiteType.actId) {
        segments.push({
            path: `/admin/activites/types/${activiteType.actId}`,
            name: activiteType.actLabel || "Type d'activité"
        });
    }

    return segments;
};



